Namespace 'Models.Visitors'

class Models.Visitors.InstagramMessageAttachmentsVisitor
  constructor: ->
    @attachments = ''

  visit_instagram_message_text: (message) ->
    @attachments = []

  visit_instagram_message_media: (message) ->
    @attachments = message.attachments

  visit_instagram_message_story_mention: (message) ->
    @attachments = message.attachments

  visit_instagram_message_story_reply: (message) ->
    @attachments = []

  visit_instagram_message_unsupported: (message) ->
    @mainText = []
